<template>
  <div>
    <custom-page-table
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      base-key="smsUrl"
      query-path="template/disable/list"
    >
    <span slot="action" slot-scope="rowItem">
      <a @click="showShield(rowItem.record.id)">修改</a>
      <a-divider type="vertical"/>
      <a-popconfirm
        title="确认删除本条数据吗？"
        ok-text="确定"
        cancel-text="取消"
        @confirm="deleteShield(rowItem.record.id)"
      >
    <a style="color: red">删除</a>
  </a-popconfirm>
    </span>
    </custom-page-table>
    <!-- 新建屏蔽 -->
    <a-modal
      title="新建屏蔽"
      :visible="shieldVisible"
      @cancel="shieldVisible = false"
      width='650px'
      @ok="handleShieldSubmit"
      @afterClose="afterClose"
    >
      <a-form-model ref="shieldForm" :model="shieldForm" :rules="shieldRules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="选择模板" prop="disTemplateId">
          <a-select v-model="shieldForm.disTemplateId" style="width: 300px" @change="onDisabledChange"
                    placeholder="请选择">
            <a-select-option v-for="(item,index) in blackList" :key="index" :value="item.templateId">
              {{ item.templateName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="屏蔽商品ID" prop="disProId">
          <a-textarea style="width: 300px" v-model="shieldForm.disProId" placeholder="请输入商品ID,一行一个" :rows="4"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'TemplateComponent',
  data() {
    return {
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
        offsetCol: { offset: 5 }
      },
      columns: [
        {
          title: '模板ID',
          dataIndex: 'disTemplateId'
        },
        {
          title: '模板标题',
          dataIndex: 'disTemplateTitle'
        },
        {
          title: '屏蔽发送商品ID',
          dataIndex: 'disProId'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {
        disMerchantId: this.$store.getters.userInfo.merchantId,
        disPlatformId: this.getPlatformConfig().platformId
      },
      shieldForm: {
        disTemplateId: undefined,
        disTemplateTitle: '',
        disProId: ''
      },
      shieldRules: {
        disTemplateId: [
          { required: true, message: '请选择模板', trigger: 'blur' }
        ],
        disProId: [
          { required: true, message: '请输入屏蔽商品ID', trigger: 'blur' }
        ]
      },
      blackList: [],
      shieldVisible: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: ''
    }
  },
  mounted() {
    this.getBlacklistTemplateInfo()
  },
  methods: {
    afterClose() {
      this.id = ''
    },
    onDisabledChange(value) {
      let obj = this.blackList.filter(function(item) {
        return item.templateId === value
      })
      // this.shieldForm.disTemplateId = obj[0].templateId
      this.shieldForm.disTemplateTitle = obj[0].templateName
    },
    resetData() {
      this.shieldForm.disTemplateId = undefined
      this.shieldForm.disTemplateTitle = ''
      this.shieldForm.disProId = ''
    },
    showShield(id) {
      this.resetData()
      if (id) {
        this.id = id
        this.getDetail(id)
      } else {
        this.shieldVisible = true
      }
    },
    getDetail(id) {
      let params = {
        disPlatformId: this.platformId,
        disMerchantId: this.merchantId
      }
      if (id) {
        params.id = id
      }
      this.getHttpServices().getSmsApiService().post('template/disable/detail', params)
        .then(res => {
          this.shieldForm.disTemplateId = res.disTemplateId
          this.shieldForm.disTemplateTitle = res.disTemplateTitle
          this.shieldForm.disProId = res.disProId.replace(/,/g, '\n')
          this.shieldVisible = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    deleteShield(id) {
      let params = {
        disPlatformId: this.platformId,
        disMerchantId: this.merchantId,
        id: id
      }
      this.getHttpServices().getSmsApiService().post('/template/disable/del', params)
        .then(res => {
          this.$message.success('成功删除')
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    searchBts() {
      this.$refs.tableList.refresh(true)
    },
    getBlacklistTemplateInfo() {
      let params = {
        platformId: this.platformId,
        merchantId: this.merchantId
      }
      this.getHttpServices().getSmsApiService().post('base/sms/getBlacklistTemplateInfo', params)
        .then(res => {
          this.blackList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleShieldSubmit() {
      this.$refs.shieldForm.validate(valid => {
        if (valid) {
          this.submitBlackData()
        } else {
          this.getLogUtils().logWithTag('error submit!!', 'error submit!!')
          return false
        }
      })
    },
    submitBlackData() {
      let params = {
        disPlatformId: this.platformId,
        disMerchantId: this.merchantId,
        disTemplateId: this.shieldForm.disTemplateId,
        disTemplateTitle: this.shieldForm.disTemplateTitle,
        disProId: this.shieldForm.disProId.replace(/\n/g, ',')
      }
      if (this.id) {
        params.id = this.id
      }
      this.getHttpServices().getSmsApiService().post('template/disable/save', params).then(res => {
        this.shieldVisible = false
        this.$message.success('添加成功')
        this.$refs.tableList.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped>
</style>
